// extracted by mini-css-extract-plugin
module.exports = {"container":"FullWIdthNotification_container__3fSsI","msg":"FullWIdthNotification_msg__bCohm"};